// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"cceb90b8","483":"4f58fc3d"}[chunkId] + ".chunk.css";
};